module.exports = __webpack_public_path__ + "static/media/inhouse.4a5a241b.svg";